import { notFound } from 'next/navigation';

export const checkParamsId = (id?: string | string[]): number => {
  const idNumber = Number(id);
  if (Number.isNaN(idNumber)) {
    notFound();
  }

  return idNumber;
};
export const checkParamsIdPass = (id?: string | string[]): number | undefined => {
  const idNumber = Number(id);
  if (Number.isNaN(idNumber)) {
    return undefined;
  }
  return idNumber;
};
